module.exports = __webpack_public_path__ + "img/yq2.6c4b9dff.png";